<template>
  <el-container class="index">
    <el-header><Header /></el-header>
    <el-container>
      <el-aside :style="'background-color:' + $store.state.$vt_a">
        <Aside />
      </el-aside>
      <el-main>
        <NavigationBar />
        <Main />
        <div class="footer-beian">
          <p class="copyright-text">
            Copyright ©2020 深圳市博域篮球文化有限公司 版权所有
            工信部备案号
            <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">
              粤ICP备17030083号-4
            </a>
          </p>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { Header, Aside, Main, NavigationBar } from "./index.js";
export default {
  components: {
    Header,
    Aside,
    Main,
    NavigationBar,
  },
};
</script>

<style lang="scss" scoped>
$dt_a: #41b883;
$dt_b: #41b8838a;
$dt_c: #41b88300;
$vt_a: #35495e;
$vt_b: #35495e83;
$vt_c: #35495e00;
.index {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  > .el-header {
    height: 50px !important;
    padding: 0;
  }
  > .el-container {
    flex: 1;
    overflow: hidden;
    > .el-aside {
      width: auto !important;
    }
    > .el-main {
      padding: 0;
      margin: 0;
      position: relative;
      display: flex;
      flex-flow: column;
      height: 100%;
      .Main {
        flex: 1;
        overflow-y: auto;
        > div {
          padding: 15px;
        }
      }

      .footer-beian {
        text-align: center;
        padding: 20px 0;
        color: #999;
        font-size: 12px;
        background-color: #fff;

        .copyright-text {
          margin: 0;
          line-height: 1.8;
        }

        .beian-link {
          color: #999;
          text-decoration: none;

          &:hover {
            color: #409EFF;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
<style>
.el-main .Main > div {
  padding: 15px;
}

.el-main .Main .AsideIcon,
.el-main .Main .el-drawer__wrapper {
  padding: 0;
}

.el-main .footer-beian {
  padding: 0;
}
</style>